import { useEffect, useState } from 'react'
import { landingApi } from 'Pages/landings/newLandings/common/api'
import { Channel } from 'Pages/landings/newLandings/common/types'

export const useChannels = (order_prefix: string) => {
	const [channel, setChannel] = useState<Channel | null>(null)

	useEffect(() => {
		const getChannel = async () => {
			try {
				const res = await landingApi.getChannels(order_prefix)
				setChannel(res?.entries?.[0])
			} catch (e) {
				// eslint-disable-next-line no-console
				console.log(e)
			}
		}
		getChannel()
	}, [order_prefix])

	return { channel }
}
